/** Short browser titles: current page, top-level area, site. */
export const pageTitle = (site: string, current: string, area = ``): string =>
    [...new Set([current.trim(), area.trim(), site].filter(Boolean))].join(` | `);

const siteName = () => document.querySelector<HTMLMetaElement>(`meta[name="energikilden-brand"]`)
    ?.content === `registrerevarme` ? `Registrerevarme` : `Energikilden`;

let started = false;
let fallback = ``;

export const setPageTitle = (current: string, area = ``) => {
    fallback = pageTitle(siteName(), current, area);
    document.title = fallback;
};

// Observe mounted breadcrumbs, not detached render results. This also follows async
// details, tab changes, saved names and returning from an editor to its list.
export const startPageTitle = () => {
    if (started) return;
    started = true;
    fallback = document.title;
    const root = document.querySelector<HTMLElement>(`.pilot-content`) || document.body;
    const update = () => {
        const breadcrumb = root.querySelector<HTMLElement>(`nav[aria-label="Brødsmulesti"] .breadcrumb`);
        const labels = breadcrumb ? [...breadcrumb.children].map(item => item.textContent?.trim() || ``) : [];
        const title = labels.length ? pageTitle(siteName(), labels[labels.length - 1],
            labels.length > 1 ? labels[0] : ``) : fallback;
        if (document.title !== title) document.title = title;
    };
    update();
    new MutationObserver(update).observe(root, { childList: true, subtree: true, characterData: true });
};
